import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';

import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Models from './pages/Models';
import Arquetips from './pages/Arquetips';
import ModelEditor from './pages/ModelEditor';
import Login from './pages/Login';
import Admin from './pages/Admin';
import Compte from './pages/Compte';
import { checkAuth } from './store/authSlice';

function App() {
  const dispatch = useDispatch();
  const { isAuthenticated, loading } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(checkAuth());
  }, [dispatch]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <Router 
      future={{ 
        v7_startTransition: true,
        v7_relativeSplatPath: true 
      }}
    >
      <Toaster position="top-right" />
      <Routes>
        <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/dashboard" />} />
        {/* La pantalla de registre és ara una pestanya de /login. Aquesta ruta es queda com a
            redirecció perquè algú pot tenir l'adreça vella desada o enllaçada. */}
        <Route path="/register" element={<Navigate to="/login" replace />} />
        
        <Route path="/" element={isAuthenticated ? <Layout /> : <Navigate to="/login" />}>
          <Route index element={<Navigate to="/dashboard" />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="models" element={<Models />} />
          <Route path="arquetips" element={<Arquetips />} />
          <Route path="models/:id" element={<ModelEditor />} />
          {/* La pàgina se'n va sola si qui hi arriba no és admin. Qui protegeix de debò
              és el backend: /api/admin/* contesta 403 a tothom altre. */}
          <Route path="admin" element={<Admin />} />
          <Route path="account" element={<Compte />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;